import LoginPageBody from "../components/loginPage/LoginPageBody";

const LoginPage = () => {
    return(
        <LoginPageBody/>
    );
}

export default LoginPage;